import React, { useEffect, useState } from 'react';
import {
  getStatDataAction,
  setCurrentStatAction,
} from 'store/actions/mainPage';
import { useAppDispatch, useAppSelector } from 'hooks/redux';
import { checkTransitData, getAteForTransit } from '../constants';
import { getText } from 'services/languageService';
import { getAteLayerAction } from 'store/actions/layers';
import { layersSlice } from 'store/reducers/layers';
import {
  resetTransitionData,
  setNeedShowAteAction,
} from 'store/actions/transitData';

export const TransitData: React.FC<{
  tabType: string;
  requirements: boolean;
}> = ({ tabType, requirements }) => {
  const { isLogged, currentDataset, statisticsLayers, lang } = useAppSelector(
    (state) => state.mainPage
  );

  const {
    layer,
    dataset,
    ateRegion,
    ateCity,
    ateVC,
    from,
    ateCityType,
    ateRegionType,
    needShowAte,
  } = useAppSelector((state) => state.transitData);

  const needTransit = from === 'layers' || from === 'search';
  const { all, onlyLayer, onlyAte } = checkTransitData(
    layer,
    dataset,
    ateRegion,
    ateCity,
    ateVC
  );
  const { ateRegions } = useAppSelector((state) => state.layers);
  const [updated, setUpdated] = useState(false);
  const dispatch = useAppDispatch();
  const itemAll = {
    id: 'all',
    label: getText('SELECT_ALL'),
    name: getText('SELECT_ALL'),
    type: '',
    dataset_name: '',
  };

  useEffect(() => {
    if (updated || !currentDataset || !needTransit) return;
    if (onlyLayer && statisticsLayers.length) {
      dispatch(
        getAteLayerAction(
          'ateCities',
          {
            regions: [itemAll],
            cities: [],
            vc: [],
          },
          true
        )
      );
      // @ts-ignore
      dispatch(setCurrentStatAction('currentAteRegions', [itemAll]));

      const newLayer = statisticsLayers.find((item) => item.id === layer);

      if (newLayer) {
        dispatch(setCurrentStatAction('currentLayer', newLayer));

        const params = {
          lang,
          dataset: String(currentDataset.id),
          type: tabType,
          layer: String(newLayer.id),
          all_1: '1',
        };
        dispatch(getStatDataAction(isLogged, params));
        setUpdated(true);
      }
    }
  }, [statisticsLayers, currentDataset]);

  useEffect(() => {
    if (!needTransit || !onlyAte || updated) return;

    getAteForTransit(ateRegion, ateCity, ateRegionType, ateCityType).then(
      (res) => {
        const region = ateRegions.find((reg) => reg.id === ateRegion);
        const city = res.listCities.find((cit) => cit.id === ateCity);
        const vc = res.listVC && res.listVC.find((vc: any) => vc.id === ateVC);

        region && dispatch(setCurrentStatAction('currentAteRegions', [region]));
        city && dispatch(setCurrentStatAction('currentAteCities', [city]));
        vc && dispatch(setCurrentStatAction('currentAteVC', [vc]));

        dispatch(
          layersSlice.actions.setAte({
            param: 'ateCities',
            ate: res.listCities,
          })
        );
        dispatch(
          layersSlice.actions.setAte({ param: 'ateVC', ate: res.listVC })
        );

        setUpdated(true);
      }
    );
  }, [needTransit]);

  useEffect(() => {
    if (
      !needTransit ||
      !all ||
      !currentDataset ||
      !statisticsLayers.length ||
      updated ||
      !requirements
    )
      return;

    // #temporarily
    // getAteForTransit(ateRegion, ateCity, ateRegionType, ateCityType).then(
    //   (res) => {
    //
    //     // const region = ateRegions.find((reg) => reg.id === ateRegion);
    //     // const city = res.listCities.find((cit) => cit.id === ateCity);
    //     // const vc = res.listVC && res.listVC.find((vc: any) => vc.id === ateVC);
    //     //
    //     // console.log('all effect');
    //     // region && dispatch(setCurrentStatAction('currentAteRegions', [region]));
    //     // city && dispatch(setCurrentStatAction('currentAteCities', [city]));
    //     // vc && dispatch(setCurrentStatAction('currentAteVC', [vc]));
    //     //
    //     // dispatch(
    //     //   layersSlice.actions.setAte({
    //     //     param: 'ateCities',
    //     //     ate: res.listCities,
    //     //   })
    //     // );
    //     // dispatch(
    //     //   layersSlice.actions.setAte({ param: 'ateVC', ate: res.listVC })
    //     // );
    //
    //     // const params = {
    //     //   lang,
    //     //   dataset: String(currentDataset.id),
    //     //   type: tabType,
    //     // };
    //     //
    //     // if (ateRegion) params['ate_polygons_1[0]'] = ateRegion.toString();
    //     // if (ateCity) params['ate_polygons_2[0]'] = ateCity.toString();
    //     // if (ateVC) params['ate_polygons_3[0]'] = ateVC.toString();
    //     //
    //     // dispatch(getStatDataAction(isLogged, params)).then(() => {
    //     //   setUpdated(true);
    //     // });
    //   }

    const params = {
      lang,
      dataset: String(currentDataset.id),
      type: tabType,
    };

    if (ateRegion) params['ate_polygons_1[0]'] = ateRegion.toString();
    if (ateCity) params['ate_polygons_2[0]'] = ateCity.toString();
    if (ateVC) params['ate_polygons_3[0]'] = ateVC.toString();

    dispatch(getStatDataAction(isLogged, params)).then(() => {
      setUpdated(true);
    });
    // );
  }, [statisticsLayers, currentDataset, requirements]);

  //if there is all but didn't find layers
  useEffect(() => {
    if (!needShowAte || !needTransit) return;
    getAteForTransit(ateRegion, ateCity, ateRegionType, ateCityType).then(
      (res) => {
        const region = ateRegions.find((reg) => reg.id === ateRegion);
        const city = res.listCities.find((cit) => cit.id === ateCity);
        const vc = res.listVC && res.listVC.find((vc: any) => vc.id === ateVC);

        region && dispatch(setCurrentStatAction('currentAteRegions', [region]));
        city && dispatch(setCurrentStatAction('currentAteCities', [city]));
        vc && dispatch(setCurrentStatAction('currentAteVC', [vc]));

        dispatch(
          layersSlice.actions.setAte({
            param: 'ateCities',
            ate: res.listCities,
          })
        );
        dispatch(
          layersSlice.actions.setAte({ param: 'ateVC', ate: res.listVC })
        );

        dispatch(setNeedShowAteAction(false));
        setUpdated(true);
      }
    );
  }, [needShowAte]);

  useEffect(() => {
    if (updated) {
      dispatch(resetTransitionData(tabType));
    }
  }, [updated]);

  return null;
};
